/* eslint-disable @typescript-eslint/explicit-function-return-type */
import config from '../config/index';

export async function getNotificationContexts() {
  return await fetch(`${config.ruleServerUrl}/users/notification-contexts`, {
    credentials: 'include',
    method: 'GET',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-type': 'application/json'
    }
  })
    .then(r => {
      return r.json();
    })
    .catch(err => {
      console.log(err);
    });
}

export async function getEmailTemplates() {
  return await fetch(`${config.ruleServerUrl}/users/email-templates`, {
    credentials: 'include',
    method: 'GET',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-type': 'application/json'
    }
  })
    .then(r => {
      return r.json();
    })
    .catch(err => {
      console.log(err);
    });
}
